import { render, staticRenderFns } from "./promotionCreate.vue?vue&type=template&id=5d25ba78&scoped=true"
import script from "./promotionCreate.vue?vue&type=script&lang=js"
export * from "./promotionCreate.vue?vue&type=script&lang=js"
import style0 from "./promotionCreate.vue?vue&type=style&index=0&id=5d25ba78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25ba78",
  null
  
)

export default component.exports